// Amazon redirection for Magnesium Tropfen
// Loaded on all pages (see snippets/page-scripts.liquid).
// Activates when a visitor opens any page with a matching utm_medium or utm_source, or an srsltid
// parameter. It then saves a session cookie and stays active on every page until the browser is closed.
(function () {
	// Mobile drawer menu + desktop header dropdown
	const MENU_LINK_SELECTOR = '.panel-list__wrapper a, .header__link-list a';
	const LINK_TEXT = 'Restaxil® Tropfen';
	const TARGET_URL = '/products/restaxil-tropfen';

	const COOKIE_NAME = 'amazon_tropfen_redirect';

	const UTM_MEDIUMS = ['cpc', 'native', 'paidsocial', 'print', 'email', 'sms', 'social', 'llm'];
	const UTM_SOURCES = ['google', 'outbrain'];

	function hasMatchingParams() {
		const params = new URLSearchParams(window.location.search);
		const medium = (params.get('utm_medium') || '').trim().toLowerCase();
		const source = (params.get('utm_source') || '').trim().toLowerCase();

		return UTM_MEDIUMS.includes(medium) || UTM_SOURCES.includes(source) || params.has('srsltid');
	}

	function hasCookie() {
		return document.cookie.split('; ').some(function (cookie) {
			return cookie.indexOf(COOKIE_NAME + '=') === 0;
		});
	}

	function setCookie() {
		// No expires / max-age: session cookie, removed when the browser is closed
		const secure = window.location.protocol === 'https:' ? '; Secure' : '';
		document.cookie = COOKIE_NAME + '=1; path=/; SameSite=Lax' + secure;
	}

	function isActive() {
		if (hasCookie()) return true;

		if (hasMatchingParams()) {
			setCookie();
			return true;
		}

		return false;
	}

	function isTargetLink(link) {
		return link.textContent.includes(LINK_TEXT);
	}

	function overwriteLinks() {
		document.querySelectorAll(MENU_LINK_SELECTOR).forEach(function (link) {
			if (isTargetLink(link) && link.getAttribute('href') !== TARGET_URL) {
				link.setAttribute('href', TARGET_URL);
			}
		});
	}

	function init() {
		if (!isActive()) return;

		console.log('MAGNISIUM PAGE');

		overwriteLinks();

		// Re-apply whenever the menu is re-rendered or the href is set back
		new MutationObserver(overwriteLinks).observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['href'],
		});

		// Force the navigation even if another script handles the click
		document.addEventListener(
			'click',
			function (event) {
				if (event.metaKey || event.ctrlKey || event.shiftKey) return;

				const link = event.target.closest(MENU_LINK_SELECTOR);
				if (!link || !isTargetLink(link)) return;

				event.preventDefault();
				event.stopImmediatePropagation();
				window.location.href = TARGET_URL;
			},
			true
		);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
